<template>
    <inertia-head>
        <title>{{ metaTitle }}</title>
        <link rel="canonical" :href="canonical" />
        <meta name="description" content="Massor av rabatter och erbjudanden som passar hela familjen. Rabattkoder för allt ifrån hemmet, träning, ekonomi, barnkläder, bilen till mat online.">
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/assets/frontend/hero.jpg" />
    </inertia-head>

    <breadcrumb>
        <breadcrumb-item>
            <inertia-link href="/">Hem</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item :last="true">
            Alla företag
        </breadcrumb-item>
    </breadcrumb>

    <main role="main" class="all-companies main page-content-padding">
        <div class="container">
            <h1 class="page-heading">{{ pageTitle }}</h1>

            <p class="text-dark px-2 mx-auto" style="max-width: 800px; margin-top: 25px;">
                Här har vi samlat alla våra härliga företag som förser Sveriges familjer med grymma rabatter och erbjudanden. Hantverkare, pt-tränare, mat online, ica-butiker och lokala företagare nära dig. Här hittar du det mesta som en barnfamilj behöver!
            </p>

            <div style="margin-top: 25px;">
                <company-type-filter
                    @changed="update"
                    v-model:showLocals="locals"
                    v-model:showWebshops="webshops">
                </company-type-filter>

                <select class="mt-2 badge badge-secondary ms-2" v-model="selectedCity" @change="update">
                    <option :value="null">Hela landet</option>
                    <option v-for="city in cities" :value="city.slug" :selected="selectedCity === city.slug">{{ city.name }}</option>
                </select>
            </div>

            <div class="row mt-2 mb-5">
                <div class="col-6 col-md-3 px-2" v-for="(company, index) in companies" :key="company.slug">
                    <inertia-link :href="routeTarget(company)">
                        <div class="company-item">
                            <!-- <icon name="heart" class="favourite"></icon> -->
                            <img class="logo" v-if="company.logo" :src="company.logo"  :alt="company.name" :title="company.name" loading="lazy">
                            <img class="logo" v-else>
                        </div>
                    </inertia-link>
                </div>
            </div>

            <infinite-loading @in-view="infiniteHandler">
                <template #loading>
                    Laddar...
                </template>
            </infinite-loading>
        </div>
    </main>
</template>

<script>
import CompanyTypeFilter from '@/components/CompanyTypeFilter.vue';
import { router } from '@inertiajs/vue3'

export default {
    props: ['data', 'paginator', 'canonical'],

    components: { CompanyTypeFilter },

    data() {
        return {
            companies: this.data,
            companiesPaginator: this.paginator,
            locals: true,
            webshops: true,
            selectedCity: null,
        };
    },

    mounted () {
        let params = (new URL(document.location)).searchParams;

        if (params.has('city')) {
            this.selectedCity = params.get('city');
        }

        if (params.has('webshops')) {
            this.webshops = JSON.parse(params.get('webshops'));
        }

        if (params.has('locals')) {
            this.locals = JSON.parse(params.get('locals'));
        }
    },

    computed: {
        cities() {
            return this.$page.props.cities;
        },

        pageTitle () {
            return this.title();
        },

        metaTitle () {
            return this.title(true);
        }
    },

    methods: {
        title (metatitle = false) {
            var title = `${metatitle ? 'Nya rabattkoder - ' : ''}Alla`;

            if (this.webshops && !this.locals) {
                title += ` E-handel företag`;
            }

            if (!this.webshops && this.locals) {
                title += ` Lokala företag`;
            }

            if (this.webshops && this.locals) {
                title += ` företag`;
            }

            if (this.selectedCity) {
                title += ` i ${this.cities.find((c) => c.slug === this.selectedCity).name}`;
            }

            return title;
        },

        urlParams () {
            let params = {
                locals: this.locals,
                webshops: this.webshops
            };

            if (this.selectedCity) {
                params.city = this.selectedCity;
            }

            return Object.keys(params).map(key => key + '=' + params[key]).join('&');
        },

        update (e) {
            router.visit(`/alla-foretag?${this.urlParams()}`);
        },

        getCompanies (loadMore = false) {
            let url = `${this.companiesPaginator.next_page_url}&${this.urlParams()}`;

            return axios.get(url);
        },

        infiniteHandler($state) {
            if (!this.companiesPaginator.next_page_url) {
                $state.complete();
                return;
            }

            this.getCompanies().then(response => {
                this.companies = this.companies.concat(response.data.data);
                this.companiesPaginator = response.data.paginator;
                $state.loaded();
            });
        },

        routeTarget(company) {
            if (!this.selectedCity) {
                return `/${company.slug}`;
            }
            return `/${company.slug}/${this.selectedCity}`;
        },
    }
}
</script>
